import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getSupportedDocuments, processDocument, verifyFace } from '../api';

import { AxiosError } from 'axios';
import type { RootState } from './../store';

interface DocumentMaster {
	result: string;
	DocumentName: string;
}
const initialState = {
	load: null,
	passport: null,
	idFront: false,
	idBack: false,
	guid: null,
	documentFrontBase64Image: null,
	documentBackBase64Image: null,
	faceImageBase64Image: null,
	isPassport: null,
	error: {
		fetchPassport: null,
		fetchIdFront: null,
		fetchIdBack: null,
		submitDocument: null,
		isReload: null,
		verifyFaceImage: null,
	},
	documentMetaData: null,
	isPostComplete: false,
	//lastName: null,
	isFaceVerificationComplete: false,
	isFaceVerificationError: false,
	docTypeDescription: null,
	isUploadingPassport: null,
	supportDocs: null,
	scannedDocumentNumbers: [] as string[],
} as any;

export const submitDocument = createAsyncThunk<
	{
		documentFrontBase64Image: string;
		documentBackBase64Image: string;
		faceImageBase64Image: string;
		guid: string;
		documentMetaData: object;
		isPassport: boolean;
		docTypeDescription: string;
		isUploadingPassport: boolean;
		profileID: number;
		documentNumber: string;
	},
	{
		token: string;
		profileID: number;
		pmsConfirmationNo: string;
		docufront: string;
		docuback: string;
		isPassport: boolean;
		propertyCode: string; //added new
		lastName: string;
		fullName: string;
		currentProfileIndex: number;
		isChild: boolean;
		childAgeLimit: number;
		adultAgeLimit: number;
		scannedDocumentNumbers: string[];
	},
	{
		rejectValue: any;
	}
>('Profile/SubmitDocument', async (documentParam, _thunkAPI) => {
	const {
		token,
		profileID,
		pmsConfirmationNo,
		docufront,
		docuback,
		isPassport,
		propertyCode,
		lastName,
		fullName,
		currentProfileIndex,
		isChild,
		childAgeLimit,
		adultAgeLimit,
		scannedDocumentNumbers,
	} = documentParam;

	clearError();

	const response = await processDocument(
		token,
		profileID,
		pmsConfirmationNo,
		docufront,
		docuback,
		isPassport,
		propertyCode
	);

	// Check the HTTP status code in the response
	if (response.status === 404) {
		return _thunkAPI.rejectWithValue({
			error: 'Resource not found (404)',
			response: response.data, // Include the response data
		});
	}

	if (response?.data) {
		if (response?.data?.result === false) {
			if (response?.data?.message === 'Document is Expired') {
				return _thunkAPI.rejectWithValue({
					error:
						'Please note that the document you are attempting to upload has expired. Kindly provide a valid and up-to-date document for online check-in.',
					response: response.data, // Include the response data
				});
			} else if (response?.data?.message === 'Document is Invalid') {
				return _thunkAPI.rejectWithValue({
					error:
						'Oops! It seems the document provided is not valid. Please upload a valid document to proceed with the online check-in process.',
					response: response.data, // Include the response data
				});
			} else {
				return _thunkAPI.rejectWithValue({
					error: response?.data?.message ?? 'Some error occured',
					response: null, // Include the response data
				});
			}
		}
		if (response?.data?.data) {
			const expDateDoc = response?.data?.data.expiryDate;
			const lastNameDoc = response?.data?.data.lastName;

			console.log(
				'lastName$$$' +
					lastNameDoc +
					',' +
					lastName +
					',' +
					lastNameDoc.includes(lastName) +
					',' +
					profileID
			);

			if (response?.data?.data?.documentNumber) {
				/* eslint-disable no-debugger */
				debugger;
				const scannedDocumentNumber = response?.data?.data?.documentNumber;
				if (scannedDocumentNumbers.includes(scannedDocumentNumber)) {
					return _thunkAPI.rejectWithValue({
						error: 'Document already scanned',
						response: null, // Include the response data
					});
				}
			}

			if (isPassport) {
				if (response?.data?.data?.documentClassCode !== 'P') {
					return _thunkAPI.rejectWithValue({
						error: 'Please upload passport',
						response: null, // Include the response data
					});
				}
			} else {
				if (response?.data?.data?.documentClassCode === 'P') {
					return _thunkAPI.rejectWithValue({
						error: 'Please upload valid ID document',
						response: null, // Include the response data
					});
				}
			}
			if (lastNameDoc) {
				if (
					lastName !== undefined &&
					lastName !== null &&
					lastNameDoc !== null &&
					//lastNameDoc.toUpperCase() != lastName.toUpperCase() &&
					// lastNameDoc.toUpperCase().includes(lastName.toUpperCase()) === false &&
					profileID > 0
				) {
					const docFullName =
						response?.data?.data?.firstName +
						' ' +
						response?.data?.data?.middleName +
						' ' +
						response?.data?.data?.lastName;

					// const [docFirstName, docLastName] = docFullName.split(' ');
					// const namesExistInOperaFullName =
					// 	(fullName.toLowerCase().includes(docFirstName.toLowerCase()) &&
					// 		fullName.toLowerCase().includes(docLastName.toLowerCase())) ||
					// 	(fullName.toLowerCase().includes(docLastName.toLowerCase()) &&
					// 		fullName.toLowerCase().includes(docFirstName.toLowerCase()));

					const operaFullName = fullName;
					const docNames = docFullName.toLowerCase().split(' ');
					const operaNames = operaFullName.toLowerCase().split(' ');
					/* eslint-disable no-debugger */
					//debugger;
					/* eslint-enable no-debugger */
					let matchingCount = 0;
					for (const docName of docNames) {
						if (docName !== '' && operaNames?.includes(docName)) {
							matchingCount++;
						}
					}

					if (matchingCount < 2) {
						console.log('last name not matching with pms last name');
						return _thunkAPI.rejectWithValue({
							error: 'Document Name not matching with Reservation',
							response: response.data, // Include the response data
						});
					}
				}
			}
			/* eslint-disable no-debugger */
			console.log(
				'isChild--' + isChild + ',' + adultAgeLimit + ',' + childAgeLimit
			);
			/* eslint-enable no-debugger */
			if (isChild === false && adultAgeLimit > 0) {
				const dob = new Date(response?.data?.data.dateOfBirth);
				const today = new Date();
				let age = today.getFullYear() - dob.getFullYear();
				if (
					today.getMonth() < dob.getMonth() ||
					(today.getMonth() === dob.getMonth() &&
						today.getDate() < dob.getDate())
				) {
					age--;
				}
				const isAgeLess = age < adultAgeLimit;

				if (isAgeLess) {
					console.log('The person is under ' + adultAgeLimit + ' years old.');
					return _thunkAPI.rejectWithValue({
						error:
							'Ensure adult age must be ' + adultAgeLimit + ' years or above',
						response: null, // Include the response data
					});
				}
			}
			if (isChild === true && childAgeLimit > 0) {
				const dob = new Date(response?.data?.data.dateOfBirth);
				const today = new Date();
				let age = today.getFullYear() - dob.getFullYear();
				if (
					today.getMonth() < dob.getMonth() ||
					(today.getMonth() === dob.getMonth() &&
						today.getDate() < dob.getDate())
				) {
					age--;
				}
				const isUnder18 = age > childAgeLimit;

				if (isUnder18) {
					console.log('The person is under ' + childAgeLimit + ' years old.');
					return _thunkAPI.rejectWithValue({
						error: 'Ensure child age is under ' + childAgeLimit + ' years',
						response: null, // Include the response data
					});
				}
			}

			if (expDateDoc) {
				// Convert expDate and current date to Date objects
				const expirationDate = new Date(expDateDoc);
				const currentDate = new Date();

				// Compare the dates
				// if (expirationDate > currentDate) {
				// 	console.log('expDate is later than the current date');
				// 	return _thunkAPI.rejectWithValue({
				// 		error: response?.data?.message,
				// 		response: response.data, // Include the response data
				// 	});
				// } else
				if (expirationDate < currentDate) {
					console.log('expDate is earlier than the current date');
					return _thunkAPI.rejectWithValue({
						error: 'Expired Document',
						response: response.data, // Include the response data
					});
				} else {
					console.log('expDate is the same as the current date');
				}
			} else {
				console.log('expDate is not available');
			}
		}
	}

	console.log('response process-->' + JSON.stringify(response));

	return {
		documentFrontBase64Image: response?.data?.data?.documentFrontBase64Image,
		documentBackBase64Image: response?.data?.data?.documentBackBase64Image,
		faceImageBase64Image: response?.data?.data?.faceimage,
		guid: response?.data?.data?.transactionGUID,
		documentMetaData: response?.data?.data,
		isPassport: isPassport,
		profileID: response?.data?.data?.profileID,
		docTypeDescription: response?.data?.data?.docTypeDescription,
		isUploadingPassport: isPassport,
		isFinished: true,
		documentNumber: response?.data?.data?.documentNumber,
	};
});

export const fetchPassport = createAsyncThunk(
	'Profile/FetchPassport',
	async (content: string, thunkAPI) => {
		const passport = await fetch(content);
		const blob = await passport.blob();
		return content;
	}
);

export const fetchIdFront = createAsyncThunk(
	'Profile/FetchIdFront',
	async (content: string, thunkAPI) => {
		const idFront = await fetch(content);
		const blob = await idFront.blob();
		return content;
	}
);

export const fetchIdBack = createAsyncThunk(
	'Profile/FetchIdBack',
	async (content: string, thunkAPI) => {
		const idBack = await fetch(content);
		const blob = await idBack.blob();
		return content;
	}
);

export const verifyFaceImage = createAsyncThunk<
	{
		guid?: string;
		message?: string;
		faceMatchingSimilarityStatus?: any;
	},
	{
		token?: string;
		image?: string;
		transactionGUID?: string;
	},
	{
		rejectValue: any;
	}
>('Document/VerifyFaceImage', async (documentParam, thunkAPI) => {
	try {
		clearError();

		const response = await verifyFace(
			documentParam?.token,
			documentParam?.image,
			documentParam?.transactionGUID
		);

		console.log('face match ==', response?.data?.message);

		if (response?.data?.result === false) {
			return thunkAPI.rejectWithValue({
				error: 'Face match failed', //response?.data?.message, by default show generic response
			});
		} else {
			return response.data; // Assuming you want to return the data property
		}
	} catch (error) {
		console.error('Error in verifyFaceImage:', error);
		throw error; // Re-throw the error to let the caller handle it
	}
});

export const fetchSupportedDocs = createAsyncThunk<object, { token: string }>(
	'Reservation/fetchSupportedDocs',
	async (token, thunkAPI) => {
		const response = await getSupportedDocuments(token);
		return response?.data?.data;
	}
);

const documentSlice = createSlice({
	name: 'document',
	initialState,
	reducers: {
		clear: (state) => {
			state.passport = null;
			state.idFront = null;
			state.idBack = null;
			// state.guid = null;
			state.documentFrontBase64Image = null;
			state.documentBackBase64Image = null;
			state.faceImageBase64Image = null;
			state.isPassport = null;
			state.profileID = null;
			state.error = {
				fetchPassport: null,
				fetchIdFront: null,
				fetchIdBack: null,
				submitDocument: null,
				verifyFaceImage: null,
			};
			state.documentMetaData = null;
			//state.lastName = null;
			state.documentType = null;
			state.docTypeDescription = null;
			state.isUploadingPassport = null;
		},
		addScannedDocumentNumber: (state, action) => {
			const newDocumentNumber = action.payload;
			if (!state.scannedDocumentNumbers.includes(newDocumentNumber)) {
				state.scannedDocumentNumbers.push(newDocumentNumber);
			}
		},
		popDocumentNumber: (state) => {
			if (state.scannedDocumentNumbers.length > 0)
				state.scannedDocumentNumbers.pop();
		},
		resetPostComplete: (state) => {
			state.isPostComplete = false;
		},
		resetFaceVerificationComplete: (state) => {
			state.isFaceVerificationComplete = false;
			state.isFaceVerificationError = false;
		},
		resetLoader: (state) => {
			state.load = false;
		},
		setDocumentSubmissionResponse: (state, action) => {
			state.documentSubmissionResponse = action.payload;
		},
		clearError: (state) => {
			state.error = {
				fetchPassport: null,
				fetchIdFront: null,
				fetchIdBack: null,
				submitDocument: null,
				isReload: null,
				verifyFaceImage: null,
			};
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPassport.fulfilled, (state, action) => {
			state.passport = action?.payload;
			console.log('fetchPassport--' + JSON.stringify(state.error));
			state.error.fetchPassport = null;
		});

		builder.addCase(fetchPassport.rejected, (state, action) => {
			state.error.fetchPassport = action?.error;
		});

		builder.addCase(fetchIdFront.fulfilled, (state, action) => {
			state.idFront = action?.payload;
			state.error.fetchIdFront = null;
		});

		builder.addCase(fetchIdFront.rejected, (state, action) => {
			state.error.fetchIdFront = action?.error;
		});

		builder.addCase(fetchIdBack.fulfilled, (state, action) => {
			state.idBack = action?.payload;
			state.error.fetchIdBack = null;
		});

		builder.addCase(fetchIdBack.rejected, (state, action) => {
			state.error.fetchIdBack = action?.error;
		});

		builder.addCase(submitDocument.fulfilled, (state, action) => {
			console.log('action?.payload?.guid' + action?.payload?.guid);

			state.documentFrontBase64Image =
				action?.payload?.documentFrontBase64Image;
			state.documentBackBase64Image = action?.payload?.documentBackBase64Image;
			state.faceImageBase64Image = action?.payload?.faceImageBase64Image;
			state.guid = action?.payload?.guid;
			state.isPassport = action?.payload?.isPassport;
			state.documentMetaData = action?.payload?.documentMetaData;
			state.docTypeDescription = action?.payload?.docTypeDescription;
			state.isUploadingPassport = action?.payload?.isPassport;

			state.lastName = state.documentMetaData?.surname ?? null;

			state.profileID = action?.payload?.profileID;

			// state.error.submitDocument = null;
			state.isPostComplete = true;

			state.error = {
				fetchPassport: null,
				fetchIdFront: null,
				fetchIdBack: null,
				submitDocument: null,
				verifyFaceImage: null,
			};
		});

		builder.addCase(submitDocument.rejected, (state, action) => {
			console.log('state.error--' + JSON.stringify(state.error));
			console.log(
				'state.error.payload--' + JSON.stringify(action?.payload?.error)
			);
			console.log('state.errorcode--' + JSON.stringify(state.error.code));

			//for invalid documents and all
			if (action?.payload?.response?.result == false) {
				action.error.message = action?.payload?.response?.message;
				state.error.submitDocument = action?.error;
				state.error.isReload = false;
			}
			if (action?.error?.code == AxiosError.ERR_BAD_REQUEST) {
				//action.error.message = 'Please contact front office for assistance';
				action.error.message =
					'Oops! It seems the document provided is not valid. Please upload a valid document to proceed with the online check-in process.';
				state.error.submitDocument = action?.error;
				state.error.isReload = false;
			}
			if (action?.error?.code == '404') {
				//action.error.message = 'Please contact front office for assistance';
				action.error.message =
					'Oops! It seems the document provided is not valid. Please upload a valid document to proceed with the online check-in process.';
				state.error.submitDocument = action?.error;
				state.error.isReload = false;
			}
			if (
				action?.error?.message == 'Rejected' &&
				action?.payload?.error == 'Expired Document'
			) {
				action.error.message =
					'Please note that the document you are attempting to upload has expired. Kindly provide a valid and up-to-date document for online check-in.';
				state.error.submitDocument = action?.error;
				state.error.isReload = false;
			} else if (
				action?.error?.message == 'Rejected' &&
				action?.payload?.error == 'Document Name not matching with Reservation'
			) {
				action.error.message = 'Document Name not matching with Reservation';
				state.error.submitDocument = action?.error;
				state.error.isReload = false;
			} else {
				/* eslint-disable no-debugger */
				//debugger;
				/* eslint-enable no-debugger */
				if (action?.error?.message == 'Rejected') {
					action.error.message = action?.payload?.error;

					state.error.submitDocument = action?.error;
					state.error.isReload = false;
				}
			}

			state.isPostComplete = true;
		});
		builder.addCase(verifyFaceImage.pending, (state, action) => {
			state.isFaceVerificationComplete = false;
			state.isFaceVerificationError = false;
		});
		builder.addCase(verifyFaceImage.rejected, (state, action) => {
			console.log('verify image1==>' + JSON.stringify(action?.payload ?? ''));
			console.log('verify image12==>' + JSON.stringify(action.error ?? ''));

			// state.error.message = action?.payload?.error ?? '';

			// state.error = action?.payload?.error ?? '';

			action.error.message = action?.payload?.error ?? '';
			state.error.submitDocument = action?.error;

			// state.error.verifyFaceImage = action?.payload?.error ?? '';
			state.isFaceVerificationComplete = false;
			state.isFaceVerificationError = true;
			console.log('state.error==>' + JSON.stringify(state.error ?? ''));
		});

		builder.addCase(verifyFaceImage.fulfilled, (state, action) => {
			console.log('verify image==>' + JSON.stringify(action?.payload ?? ''));
			state.isFaceVerificationComplete = true;
			state.error = {
				fetchPassport: null,
				fetchIdFront: null,
				fetchIdBack: null,
				submitDocument: null,
				verifyFaceImage: null,
			};
		});

		builder.addCase(fetchSupportedDocs.fulfilled, (state, action) => {
			if (action?.payload !== null && action?.payload !== undefined) {
				const uniqueStrings: DocumentMaster[] = [];
				const seenStrings: string[] = [];
				const docs = action?.payload as DocumentMaster[];
				docs.forEach((str: any) => {
					if (!seenStrings?.includes(str?.DocumentName)) {
						uniqueStrings.push(str);
						seenStrings.push(str?.DocumentName);
					}
				});
				state.supportDocs = uniqueStrings;
			} else {
				state.supportDocs = null;
			}
		});

		builder.addCase(fetchSupportedDocs.rejected, (state, action) => {
			state.supportDocs = null;
		});
	},
});

export default documentSlice.reducer;
export const selectDocuments = (state: RootState) => state.document;

export const {
	clear,
	clearError,
	resetPostComplete,
	resetFaceVerificationComplete,
	resetLoader,
	setDocumentSubmissionResponse,
	addScannedDocumentNumber,
	popDocumentNumber,
} = documentSlice.actions;
